import React from 'react'
import { connect } from 'react-redux'
import { nullDate } from '../../public/utility'
import { doGetOverTimeApply, doSaveOverTimeApply, doDeleteOverTimeApply, doGetHours } from '../../reducers/actions'
import { hasChangedValues, getFormValue, changeItemsValue } from '../../public/utility/formValues'
import { doOverTimeApplyAction } from '../../business/OverTimeApplyAction'
class OverTimeApply extends React.Component {
    state = {
        changedValues基本信息: {},
        id: this.props.match.params.id,
    }

    componentDidMount = () => {
        const { id } = this.state
        this.doGetOverTimeApply(id)
    }
    componentWillUnmount = () => {
        this.unmount = true
    }
    doGetOverTimeApply = (id) => {
        const { dispatch, taskName } = this.props
        dispatch(doGetOverTimeApply({
            id: id || 0,
            taskName,
            onEnd: ({ errorMessage, initValues基本信息, }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {}, })
                }
            }
        }))
    }

    handlerSave = () => {
        const { dispatch } = this.props
        const { id, changedValues基本信息 } = this.state
        dispatch(doSaveOverTimeApply({
            id,
            changedValues基本信息,
            onEnd: ({ errorMessage, id }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    Ext.toast('保存成功')
                    this.setState({ id })
                    this.doGetOverTimeApply(id)
                }
            }
        }))
    }

    handlerClose = () => {
        const { } = this.props
        if (!this.bChanged()) {
            window.history.back()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', () => window.history.back())
    }

    doGetHours = (start, end, filed) => {
        const { dispatch } = this.props
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        const searchStamp = this.searchStamp = Date.now()
        clearTimeout(this.tmrSearch), this.tmrSearch = null
        dispatch(doGetHours({
            startDate: values[start],
            endDate: values[end],
            personName: values.员工全称,
            onEnd: ({ errorMessage, hours }) => {
                if (this.unmount || searchStamp !== this.searchStamp) return
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    changeItemsValue(this, '基本信息', filed, hours)
                }
            }
        }))
    }

    handleChange = (start, end, filed) => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        if (values[start] && values[start] !== nullDate && values[end] && values[end] !== nullDate) {
            this.tmrSearch && (clearTimeout(this.tmrSearch), this.tmrSearch = null)
            this.tmrSearch = setTimeout(this.doGetHours(start, end, filed), 200)
        }
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    bSave = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        const { 状态名称 } = initValues基本信息

        return Object.keys(changedValues基本信息).length > 0 && ((状态名称 == '申请中' && values.加班折算方式 && values.加班原因 && values.加班开始时间 !== nullDate && values.加班结束时间 !== nullDate) ||
            (状态名称 == '填写中' && values.是否产生误餐费 && values.实际加班开始时间 !== nullDate && values.实际加班结束时间 !== nullDate))
    }

    bSubmit = () => {
        const { initValues基本信息, changedValues基本信息, id } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        return Object.keys(changedValues基本信息).length > 0
    }

    handelSubmit = (action, title) => {
        const { dispatch, showDetail } = this.props
        const { id } = this.state
        doOverTimeApplyAction(dispatch, title, { id: id, action: action, onSave: this.handlerClose, showDetail: showDetail })
    }

    handlerDelete = () => {
        const { dispatch, onSave } = this.props
        const { id } = this.state
        Tyan.pubForm.showConfirm('确定要删除？', () =>
            dispatch(doDeleteOverTimeApply({
                id,
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onSave && onSave()
                        window.history.back()
                    }
                }
            })))
    }

    fieldset基本信息 = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        const { 状态名称, 是否需服务单位审批 } = initValues基本信息
        return [
            { _text: '申请编号', disabled: true, },
            { _date: '创建日期', disabled: true, },
            { _text: '员工编号', disabled: true, },
            { _text: '员工姓名', disabled: true, },
            { _text: '部门名称', disabled: true, },
            { _text: '职务名称', disabled: true, },
            { _datetime: '加班开始时间', required: true, onChange: () => this.handleChange('加班开始时间', '加班结束时间', '加班时长'), disabled: 状态名称 !== '申请中' },
            { _datetime: '加班结束时间', required: true, onChange: () => this.handleChange('加班开始时间', '加班结束时间', '加班时长'), disabled: 状态名称 !== '申请中' },
            { _number: '加班时长', disabled: true },
            { _select: '加班折算方式', options: ['调休', '加班费'], disabled: 状态名称 !== '申请中', required: true },
            { _select: '服务单位', options: values.items服务单位, disabled: !(状态名称 == '申请中' && values.加班折算方式 == '加班费') },
            { _text: '加班原因', maxRows: 3, required: true, disabled: 状态名称 !== '申请中' },
            { _text: '备注', maxRows: 3, disabled: 状态名称 !== '申请中' },
            { _files: '附件', disabled: 状态名称 !== '申请中' },
            { _datetime: '实际加班开始时间', required: true, cdt: () => 是否需服务单位审批 == 2, onChange: () => this.handleChange('实际加班开始时间', '实际加班结束时间', '实际加班时长'), disabled: 状态名称 !== '填写中' },
            { _datetime: '实际加班结束时间', required: true, cdt: () => 是否需服务单位审批 == 2, onChange: () => this.handleChange('实际加班开始时间', '实际加班结束时间', '实际加班时长'), disabled: 状态名称 !== '填写中' },
            { _number: '实际加班时长(h)', name: '实际加班时长', cdt: () => 是否需服务单位审批 == 2, disabled: true },
            { _radio: '是否产生误餐费', items: ['是', '否'], required: true, cdt: () => 是否需服务单位审批 == 2, disabled: 状态名称 !== '填写中' }
        ]
    }

    fieldset流转日志 = () => {
        return [
            { _html: '', name: '流转日志', minWidth: '95%', style: { textAlign: 'left' } }]
    }
    
    render() {
        const { showMessage: Message, showBody: Body, readOnly } = this.props
        const { errorMessage, id, initValues基本信息, } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const { 状态, 状态名称, 提交时间 } = initValues基本信息
        const bSubmit = this.bSubmit()
        return <Body data={this}
            controls={
                readOnly ? [
                    { _button: this.bChanged() && '取消' || '关闭', icon: '', handler: this.handlerClose }
                ] : [
                    { _button: 状态名称 != '申请中' ? '确认' : '提交', icon: '', handler: () => this.handelSubmit(`${状态名称}.提交`, '提交'), cdt: () => id > 0 && (状态名称 == '申请中' || 状态名称 == '填写中'), disabled: bSubmit },
                    { _flow: 'OverTimeApplyFlow', disabled: this.bSave(), cdt: () => id > 0, id: getFormValue(this, '基本信息', 'ArchivesID'), onFinish: () => window.history.back() },
                    { _button: '保存', icon: '', handler: this.handlerSave, disabled: !this.bSave(), cdt: () => 状态 == 1, },
                    { _button: '删除', icon: '', ui: 'action decline alt', handler: this.handlerDelete, cdt: () => id > 0 && 状态 == 1 && 提交时间 == nullDate },
                    { _button: this.bChanged() && '取消' || '关闭', icon: '', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '加班申请单', name: '基本信息', _fieldset: this.fieldset基本信息(), forceDisabled: 状态 !== 1, docked: 'top', height: '68%', },
                    { title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), fullblock: true },
                ]
            }
        />
    }
}

export default connect()(OverTimeApply)